export const services = {
  Bride: [
    {
      id: 0,
      duration: 90,
      price: ['$150', '$225', '$150'],
      service: {
        name: 'Wedding Trial Hair',
        description:
          'Includes an in-depth consultation, step-by-step styling, and placing of extensions, a veil, and/or hair accessories.',
        isInformational: false,
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 1,
      duration: 90,
      price: ['$175', '$250', '$175'],
      service: {
        name: 'Wedding Trial Makeup',
        description:
          'Includes an in-depth consultation, step-by-step application, and false lashes.',
        isInformational: false,
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 2,
      duration: 90,
      price: 0,
      service: {
        name: 'Wedding Day Hair',
        description:
          'From whimsical waves to a structured updo, your wedding day hairstyle includes the application of a veil, comb, accessories and/or extensions. (We recommend setting up a trial beforehand.)',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$150', '$225', '$175'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 3,
      duration: 90,
      price: 0,
      service: {
        name: 'Wedding Day Makeup',
        description:
          'From natural and elevated to dramatic, our bridal-certified makeup artist will work closely with you to create your perfect wedding day makeup look. Includes false lashes and an Erno Laszlo Eye Mask. (We recommend setting up a trial beforehand.)',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$175', '$250', '$200'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
  ],
  'Bridal Party': [
    {
      id: 0,
      duration: 60,
      price: 0,
      service: {
        name: 'Bridal Party Hair Downstyle',
        description:
          'Includes any styles worn down, including straight hair, waves, accent braids and the application of extensions and/or accessories.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$100 /person', '$150 /person', '$100 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 1,
      duration: 75,
      price: 0,
      service: {
        name: 'Bridal Party Hair Upstyle',
        description:
          'Includes any styles worn up, including ponytails, braids, buns, updos, half-up styles and the application of extensions and/or accessories.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$125 /person', '$185 /person', '$125 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 2,
      duration: 60,
      price: 0,
      service: {
        name: 'Bridal Party Makeup',
        description:
          'Our team of expert makeup artists works closely with your bridal party to ensure they look and feel their best. This service includes a full makeup application and false lashes.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$115 /person', '$160 /person', '$115 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 3,
      duration: 30,
      price: 0,
      service: {
        name: 'Flower Girl Hair',
        description:
          'Our expert hair stylists will make your flower girl feel part of the bridal party by creating their desired hairstyle.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$50', '$75', '$50'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
  ],
  Events: [
    {
      id: 0,
      duration: null,
      price: null,
      service: {
        name: 'Engagement Photos',
        description:
          'All eyes are on you! Enjoy your spotlight moment with photo ready hair and makeup.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 1,
      duration: null,
      price: null,
      service: {
        name: 'Bridal Shower',
        description:
          'Start your shower day with a well-deserved pamper party of one (or invite a few friends too).',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 2,
      duration: null,
      price: null,
      service: {
        name: 'Bachelorette Party',
        description: `Whether it's girls night out or a relaxing, spa-like scene, every bachelorette needs a group Glam session.`,
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 3,
      duration: null,
      price: null,
      service: {
        name: 'Rehearsal Dinner',
        description:
          'Kick off the wedding festivities with beautiful hair and makeup the night before.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
  ],
}
